import { render } from "./Subscription.vue?vue&type=template&id=ddd10546&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"

import "./Subscription.vue?vue&type=style&index=0&id=ddd10546&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd10546"]])

export default __exports__